import { render, staticRenderFns } from "./OrganizationDetailsActivity.vue?vue&type=template&id=38d1f531&scoped=true&"
import script from "./OrganizationDetailsActivity.vue?vue&type=script&lang=js&"
export * from "./OrganizationDetailsActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d1f531",
  null
  
)

export default component.exports